<div class="container content g-0">
    <div>
        <aumico-users-passwords
            [form]="form"
            (passwordFormStatus)="onPasswordFormStatusChange($event)"
            (passwordValue)="onValidPassword($event)"
        ></aumico-users-passwords>
        <div class="button-style">
            <ham-button
                [disabled]="!isPasswordFormValid || isOOBCodeExpiredOrInvalid"
                (buttonClick)="onResetPassword()"
            >
                {{ (isResetPasswordUrl ? localizations.aumico_users_reset_password_button :
                localizations.aumico_users_signup_creating_your_account_button) | i18next}}
            </ham-button>
            <div *ngIf="form.hasError('passwordMismatch')" class="error-message">
                <span
                    hamIconShapes
                    icon="assets/hamIcons/exclamation-outline.svg"
                    [variant]="'red-transparent'"
                    [size]="'regular'"
                ></span>
                {{ 'aumico_errors_password_not_match' | i18next }}
            </div>
        </div>
        <mat-error *ngIf="backendError">{{localizations.aumico_errors_server_error| i18next }}</mat-error>
    </div>
    <div class="oobcode-expired" *ngIf="isOOBCodeExpiredOrInvalid">
        <div class="error-icon">
            <mat-icon>error</mat-icon>
        </div>
        <div class="column">
            <h6>{{localizations.aumico_googleidp_invalid_code_error_message_title | i18next }}</h6>
            <p>{{localizations.aumico_googleidp_invalid_code_error_message_content | i18next }}</p>
        </div>
        <ham-button class="resend-button" (buttonClick)="resendVerificationMailClicked()" variant="white">
            {{ questionButtonTextKey | i18next }}
        </ham-button>
    </div>
    <div class="row policy-and-subscription" *ngIf="showTermsAndSubscriptionBoxes">
        <aumico-policy-and-subscription-controls
            [form]="form"
            [localizations]="localizations"
            (pricesClicked)="openPricesLink()"
            (privacyPolicyClicked)="openPrivacyPolicyLink()"
            (termsAndConditionsClicked)="openTermsAndConditionsLink()"
            (agreementOnOrderDataProcessingClicked)="openAgreementOnOrderDataProcessingLink()"
        ></aumico-policy-and-subscription-controls>
    </div>
</div>
